import {useContext} from "react";
import {BasketContext} from "./BasketContext.tsx";

export const useBasket = () => {
    let ctx = useContext(BasketContext);
    const mCtx = ctx!
    const products = mCtx.products
    const setCurrentEditProduct = mCtx.setCurrentEditProduct
    const currentEditProduct = mCtx.currentEditProduct
    const basket = mCtx.basket
    const newBasket = mCtx.newBasket
    const total = mCtx.total
    const deleteBasket = mCtx.deleteBasket
    return {products, setCurrentEditProduct, currentEditProduct, basket, newBasket, total, deleteBasket}
}